/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'goal-content.goal-about-content.description-edit-button': 'Upravit',
  'project-actions.project-content-about.edit-description-error-description':
    'Něco se pokazilo. Zkuste to znovu za pár minut.',
  'project-content.project-content-about.edit-description-error-title': 'Popis projektu se nepodařilo upravit',
  'project-content.project-content-about.the-measure-placeholder':
    'Popište, jak vypadá úspěch a čeho doufáte, že dosáhnete.',
  'project-content.project-content-about.the-measure-title': 'Jak poznáme, že jsme úspěšní',
  'project-content.project-content-about.the-what-placeholder': 'Popište tento projekt a práci, kterou s sebou nese.',
  'project-content.project-content-about.the-what-title': 'Co děláme',
  'project-content.project-content-about.the-why-placeholder':
    'Vysvětlete, proč se tato práce děje a důvody, které ji motivují.',
  'project-content.project-content-about.the-why-title': 'Proč to děláme',
  'project-content.project-content-update-date.edited': '(upraveno)',
  'project-content.project-content-update-date.edited-tooltip': 'Upraveno {date}',
  'project-content.project-content-update-date.last-edited-by': '(naposledy upravil(a) {name})',
  'project-content.project-content-updates.add-update': 'Přidat aktualizaci',
  'project-content.project-content-updates.archived': 'Archivováno',
  'project-content.project-content-updates.at-risk': 'V ohrožení',
  'project-content.project-content-updates.cancelled': 'Zrušeno',
  'project-content.project-content-updates.completed': 'Dokončeno 🎉',
  'project-content.project-content-updates.date-changed': 'Změna data',
  'project-content.project-content-updates.edit-update': 'Upravit',
  "project-content.project-content-updates.for-date'": 'pro {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Nejnovější aktualizace',
  'project-content.project-content-updates.missed-update-message': 'Nebyla zveřejněna žádná aktualizace',
  'project-content.project-content-updates.new-due-date': 'Nový termín splnění',
  'project-content.project-content-updates.new-state': 'Nový stav',
  'project-content.project-content-updates.no-updates-description':
    'Pro tento projekt tu zatím nejsou žádné aktualizace.',
  'project-content.project-content-updates.off-track': 'Ve skluzu',
  'project-content.project-content-updates.old-due-date': 'Starý termín splnění',
  'project-content.project-content-updates.old-state': 'Starý stav',
  'project-content.project-content-updates.on-track': 'Podle plánu',
  'project-content.project-content-updates.paused': 'Pozastaveno',
  'project-content.project-content-updates.pending': 'Čekající',
  'project-content.project-content-updates.previous-updates-title': 'Předchozí aktualizace',
  'project-content.project-content-updates.share-update': 'Sdílet',
  'project-content.project-content-updates.status-changed': 'Stav byl změněn',
  'project-content.project-content-updates.write-update-button': 'Napsat aktualizaci',
  'project-update-composer.modal-post-button-label': 'Zveřejnit aktualizaci',
  'project-update-composer.modal-title': 'Zveřejněte svou aktualizaci.',
};
